export default "{\n    \"label\": \"Problema\",\n    \"placeholder\": \"Seleccione un problema\"\n}"